import { render, staticRenderFns } from "./AuthorisationEditor.vue?vue&type=template&id=ab83ddfa"
import script from "./AuthorisationEditor.vue?vue&type=script&lang=js"
export * from "./AuthorisationEditor.vue?vue&type=script&lang=js"
import style0 from "./AuthorisationEditor.vue?vue&type=style&index=0&id=ab83ddfa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports